import { Actions, Effect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { catchError, switchMap } from 'rxjs/operators';
import { THERAPIES_ACTIONS, UpdateTreatmentPlanAction } from '@ispm/therapies/store/therapies.actions';
import { Observable } from 'rxjs';

@Injectable()
export class TherapiesEffect {
  constructor(private actions$: Actions) { }

  @Effect()
  therapies$ = this.actions$
    .pipe(
      ofType(THERAPIES_ACTIONS.UPDATE_TREATMENT),
      switchMap((action) => [
        new UpdateTreatmentPlanAction(action)]),
      catchError((err) =>  {
        console.log(err);
        return Observable.of(err.error);
        }
      )
    );
}
